import { Tooltip } from '@base-ui/react/tooltip'
import type { PartProps } from '../../../lib/part-props'

interface TooltipPortalProps extends PartProps<Tooltip.Portal.Props> {}

function TooltipPortal({ children, ...props }: TooltipPortalProps) {
  return <Tooltip.Portal {...props}>{children}</Tooltip.Portal>
}

export { TooltipPortal }
